import { Temporal } from '@js-temporal/polyfill';
import { CoordinatorService } from './coordinator.service';
import { Document } from './document';
import { Notepad } from './notepad';
import { Story } from './story';
import { NotepadItem } from './notepad-item';
import { ScriptChapter } from './script-chapter';
import { StoryItem } from './story-item';

type CHILD = Chapter | Story | StoryItem | Notepad | NotepadItem;
export class Chapter {
    id: string;
    private _title = '';
    description: string;

    created: Temporal.ZonedDateTime;

    private _itemLs: CHILD[] = [];

    constructor(
        public coords: CoordinatorService,
        public parent: Document | Chapter,
        public params: any,
    ) {
        this.id = params.id || this.coords.uniqueId();
        this._title = params.title || '';
        this.description = params.description || '';
        this.created = params.created
            ? Temporal.ZonedDateTime.from(params.created)
            : this.coords.utils$.zonedDateTimeNow;

        params.itemLs?.forEach((x: any) => {
            const t = this.coords.notepad$.getInstance(x);
            t && this._itemLs.push(t as CHILD);
        });
    }

    get document(): Document {
        if (this.parent instanceof Document) return this.parent;
        else return this.parent.document;
    }

    deleteItem(itm: CHILD) {
        this._itemLs.splice(this._itemLs.indexOf(itm), 1);
        this._store();
    }

    public get title(): string {
        return this._title;
    }
    public set title(value: string) {
        this._title = value;
        this._store();
    }

    private _store() {
        this.coords.display$.markForCheck();
        this.markForManifestStore();
    }

    markForManifestStore() {
        this.parent.markForManifestStore();
    }

    save() {
        return {
            id: this.id,
            title: this._title,

            itemLs: this._itemLs.map((x) => {
                const dct: any = {
                    id: x.id,
                };
                if (x instanceof StoryItem) dct.parentId = x.story.id;
                if (x instanceof NotepadItem) dct.parentId = x.notepad.id;
                return dct;
            }),
        };
    }

    insert(insertLs: CHILD | CHILD[], itm: CHILD | undefined, isBefore = false) {
        if (!Array.isArray(insertLs)) insertLs = [insertLs];
        if (!itm) this._itemLs.push(...insertLs);
        else {
            let i = this._itemLs.indexOf(itm);
            if (i === -1) this._itemLs.push(...insertLs);
            else {
                !isBefore && i++;
                this._itemLs.splice(i, 0, ...insertLs);
            }
        }
        this._store();
    }

    move(itm: CHILD, isUp: boolean) {
        let i = this._itemLs.indexOf(itm);
        if (i === -1) return;
        if (isUp && i > 0) [this._itemLs[i], this._itemLs[i - 1]] = [
            this._itemLs[i - 1],
            this._itemLs[i],
        ];
        else if (!isUp && i < this._itemLs.length - 1) [
            this._itemLs[i],
            this._itemLs[i + 1],
        ] = [this._itemLs[i + 1], this._itemLs[i]];
        this._store();
    }

    get itemLs() {
        return Array.from(this._itemLs);
    }

    get scriptClass() {
        return new ScriptChapter(this.coords, this);
    }
}
